import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import Button from '../../components/ui/Button';
// import Logo from '../../components/Logo/Logo'; - eliminat, nefolosit
import { fadeInUp, staggerContainer, delayTransition } from '../../utils/animation';
import './HomeHero.scss';

// Imaginea de fundal a hero section-ului
const HERO_IMAGE = '/images/hero-background.png';
// Imaginea pentru nucă a fost eliminată - nefolosită
// const NUT_IMAGE = '/images/nut-illustration.png';

const HomeHero = () => {
  const { t } = useTranslation('home');
  
  return (
    <section className="hero" style={{ backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.55), rgba(0, 0, 0, 0.7)), url(${HERO_IMAGE})` }}>
      <motion.div
        className="hero__content"
        initial="hidden"
        animate="visible"
        variants={staggerContainer}
      >
        
        <motion.h1
          className="hero__title"
          initial="hidden"
          animate="visible"
          variants={fadeInUp}
          transition={delayTransition(0.3)}
        >
          <span className="hero__title-main">nucartizanal</span>
          <span className="hero__title-domain">.com</span>
        </motion.h1>
        
        <motion.p
          className="hero__subtitle"
          initial="hidden"
          animate="visible"
          variants={fadeInUp}
          transition={delayTransition(0.5)}
        >
          {t('hero.subtitle')}
        </motion.p>
        
        <motion.div
          className="hero__buttons"
          initial="hidden"
          animate="visible"
          variants={fadeInUp}
          transition={delayTransition(0.7)}
        >
          <Button 
            to="/contact"
            type="primary"
            as="link"
          >
            {t('hero.ctaPrimary')}
          </Button>
          
          <Button 
            to="/despre-noi"
            type="secondary"
            as="link"
            inverted
          >
            {t('hero.ctaSecondary')}
          </Button>
        </motion.div>
        
        <motion.div
          className="hero__features-container"
          initial="hidden"
          animate="visible"
          variants={fadeInUp}
          transition={delayTransition(0.9)}
        >
          <div className="hero__features">
            <motion.div 
              className="hero__feature"
              whileHover={{ scale: 1.05 }}
              transition={{ type: "spring", stiffness: 300 }}
            >
              <span className="hero__feature-number">{t('features.natural.title')}</span>
              <span className="hero__feature-text">{t('features.natural.subtitle')}</span>
            </motion.div>
            
            <motion.div 
              className="hero__feature"
              whileHover={{ scale: 1.05 }}
              transition={{ type: "spring", stiffness: 300 }}
            >
              <span className="hero__feature-number">{t('features.experience.title')}</span>
              <span className="hero__feature-text">{t('features.experience.subtitle')}</span>
            </motion.div>
            
            <motion.div 
              className="hero__feature"
              whileHover={{ scale: 1.05 }}
              transition={{ type: "spring", stiffness: 300 }}
            >
              <span className="hero__feature-number">{t('features.premium.title')}</span>
              <span className="hero__feature-text">{t('features.premium.subtitle')}</span>
            </motion.div>
          </div>
        </motion.div>
      </motion.div>
    </section>
  );
};

export default HomeHero;
